export enum CommonAuthRoles {
  ADMIN = 'ADMIN', // super admin
  OWNER = 'OWNER', // owner of instance
  USER = 'USER', // user of instance belonging to owner
  KIOSK = 'KIOSK',
  SSR = 'SSR', // anonymous access
}
